module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor13.f0682b8a.png";